var scope_0 = require('C:/dev/speaking-of-products-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cd4867efda2dde6900c20c3d62ecb8b4.js').default;
var scope_1 = require('C:/dev/speaking-of-products-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    